/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TopClassRow } from './TopClassRow';
import {
    TopClassRowFromJSON,
    TopClassRowFromJSONTyped,
    TopClassRowToJSON,
    TopClassRowToJSONTyped,
} from './TopClassRow';

/**
 * 
 * @export
 * @interface WidgetDataTopClassesWidgetData
 */
export interface WidgetDataTopClassesWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataTopClassesWidgetData
     */
    $type?: WidgetDataTopClassesWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<TopClassRow>}
     * @memberof WidgetDataTopClassesWidgetData
     */
    items: Array<TopClassRow>;
}


/**
 * @export
 */
export const WidgetDataTopClassesWidgetDataTypeEnum = {
    TopClasses: 'top-classes'
} as const;
export type WidgetDataTopClassesWidgetDataTypeEnum = typeof WidgetDataTopClassesWidgetDataTypeEnum[keyof typeof WidgetDataTopClassesWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataTopClassesWidgetData interface.
 */
export function instanceOfWidgetDataTopClassesWidgetData(value: object): value is WidgetDataTopClassesWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataTopClassesWidgetDataFromJSON(json: any): WidgetDataTopClassesWidgetData {
    return WidgetDataTopClassesWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataTopClassesWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataTopClassesWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(TopClassRowFromJSON)),
    };
}

export function WidgetDataTopClassesWidgetDataToJSON(json: any): WidgetDataTopClassesWidgetData {
    return WidgetDataTopClassesWidgetDataToJSONTyped(json, false);
}

export function WidgetDataTopClassesWidgetDataToJSONTyped(value?: WidgetDataTopClassesWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(TopClassRowToJSON)),
    };
}

